export default {
  'Cases types': '案件类型',
  'Possible contents of the case': '案件的可能内容',
  'Other cases': '其他情况',
  'Open for': '打开',
};
